import React from 'react';
import './featuredOn.scss';
import Logo1 from '@images/homepage/featureOn/logo1-light.svg'
import Logo2 from '@images/homepage/featureOn/logo2-light.svg'
import Logo3 from '@images/homepage/featureOn/logo3-light.svg'
import Logo4 from '@images/homepage/featureOn/logo4-light.svg'
import Logo5 from '@images/homepage/featureOn/logo5-light.svg'
import Logo6 from '@images/homepage/featureOn/logo6-light.svg'
import Logo7 from '@images/homepage/featureOn/logo7-light.svg'

function FeatureOnSection() {
  return (
      <div className='homepage-feature-on-wrapper'>
        <div className='homepage-feature-on-wrapper__feature-on-section'>
          <div className='homepage-feature-on-wrapper__feature-on-section__title'>
            Featured on
          </div>

          <div className='homepage-feature-on-wrapper__feature-on-section__logos'>
            <div className='homepage-feature-on-wrapper__feature-on-section__logos__wrapper'>
              <img width='160' height='41' src={Logo1} alt='Trafft featured on Smashing Magazine' loading="lazy"/>
              <img width='117' height='17' src={Logo2} alt='Trafft featured on Design your way' loading="lazy"/>
              <img width='108' height='49' src={Logo3} alt='Trafft featured on Codrops' loading="lazy"/>
              <img width='55' height='35' src={Logo4} alt='' loading="lazy"/>
              <img width='138' height='21' src={Logo5} alt='Trafft featured on Hongkiat' loading="lazy"/>
              <img width='135' height='23' src={Logo6} alt='Trafft featured on Graphicsfuel' loading="lazy"/>
              <img width='47' height='29' src={Logo7} alt='' loading="lazy"/>
            </div>
          </div>
        </div>
      </div>

  )
}

export default FeatureOnSection